import { render, staticRenderFns } from "./attributeManagement.vue?vue&type=template&id=36f352fb&scoped=true&"
import script from "./attributeManagement.vue?vue&type=script&lang=js&"
export * from "./attributeManagement.vue?vue&type=script&lang=js&"
import style0 from "./attributeManagement.vue?vue&type=style&index=0&id=36f352fb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f352fb",
  null
  
)

export default component.exports